import { DealsTabComponent } from "@/features";
import { Deal } from "@/types";

interface Props {
  isLoading: boolean
  deals: Deal[]
}

export const DealsTabPage = ({ isLoading, deals }: Props) => {
  return <DealsTabComponent isLoading={isLoading} deals={deals} />;
}
